/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useAccount } from "../component/context/AccountProvider";
import { getSubscriptionApi } from "../service/ZohoPlanService";
import { getMyDetails } from "../service/myDeatils";

const useUserSubscription = () => {
  const [subscriptionData, setSubscriptionsList] = useState([]);
  // const { userDetails } = useAccount() || {};
  const [userDetails, setUserDetails] = useState({})
  const getSubscriptionDetails = async () => {
    const data = await getSubscriptionApi(userDetails?.id);

    const mapDtaa = data?.data
      ?.filter((item) => {
        const currentTime = moment();
        const expiringTime = moment(
          item?.data?.subscription?.current_term_ends_at
        );
        return (
          expiringTime.isAfter(currentTime) &&
          item?.active_subscription !== "cancelled"
        );
      })
      ?.map((item) => {
        const amount = item?.data?.subscription?.amount;
        return {
          planName: item?.data?.subscription?.name,
          transcationDate: moment(
            item?.data?.subscription?.created_date
          ).format("MMM DD, YYYY"),
          invoiceId: item?.data?.invoice?.invoice_id,
          invoiceNumber: item?.data?.invoice?.invoice_number,
          tenure: item?.data?.subscription?.interval_unit,
          amount: amount,
          currencySymbol: item?.data?.subscription?.currency_symbol,
          nextBilling: moment(
            item?.data?.subscription?.current_term_ends_at
          ).format("MMM DD, YYYY"),
          planCode: item?.data?.subscription?.plan?.plan_code,
          noOfLicense: item?.licence_total_count,
          subscriptionId: item?.data?.subscription?.subscription_id,
          addonsList: item?.addons,
          validity: `${moment(item?.data?.subscription?.created_date).format(
            "MMM DD, YYYY"
          )} - ${moment(item?.data?.subscription?.current_term_ends_at).format(
            "MMM DD, YYYY"
          )}`,
          relatedPlan: item?.related_to_plan,
        };
      });
    debugger
    setSubscriptionsList(mapDtaa || []);
  };
  useEffect(() => {
    async function loadUser() {
      try {
        const resp = await getMyDetails();
        setUserDetails(resp);
      } catch (err) {
        console.error("Failed to load user details:", err);
      }
    }
    loadUser();
  }, []);

  useEffect(() => {
    if (userDetails?.email) {
      getSubscriptionDetails();
    }
  }, [userDetails?.email]);

  return {
    subscriptionData,
    refetch: getSubscriptionDetails,
  };
};

export default useUserSubscription;
